import angular from 'angular';

import rwEditorModule from 'utils/rw-editor/rw-editor-module';
import AnnouncementFormComponent from './announcement-form-component';

export default angular.module('announcement-form', [rwEditorModule.name]).component('announcementForm', new AnnouncementFormComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-form/announcement-form-module.js